import { Box, Button, Card, CardContent, Grid, Snackbar, Typography } from "@mui/material";
import React, { useState } from "react";
import { returnNetwork } from "../../utils/NetworkFunctions.js";
import { getDecimalsByCrypto } from "../../utils/cryptoCurrenciesUtils.js";

const TransferResume = ({transfer}) => {
    console.log(transfer);
    return (
		<Grid container spacing={2} sx={{ justifyContent: "center", textAlign: "center" }}>
			<Grid size={{ xs: 12, sm: 12, md: 12 }}>
				<Card sx={{ maxWidth: 500, minWidth: 500 }}>
					<CardContent>
						<Box sx={{ marginTop: 2 }}>
							<Typography sx={{ fontSize: "24px", fontWeight: "bold" }} gutterBottom>
								{"Transfer Success"}
							</Typography>
						</Box>
						<Box sx={{ marginTop: 2 }}>
							<Typography color="#0560FB" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
								{`${transfer.cryptoCurrency} ${returnNetwork(transfer.network, transfer.cryptoCurrency)} Network`}
							</Typography>
						</Box>
						<Box sx={{ marginTop: 2 }}>
							<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
								{`Transfer Sent`}
							</Typography>
						</Box>
						<Box sx={{ textAlign: "center", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
								{`$${parseFloat(transfer.currencyAmount).toFixed(2)}`}
							</Typography>
						</Box>
						<Box sx={{ textAlign: "left", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Typography sx={{ fontSize: "10px", fontWeight: "bold" }} gutterBottom>
								{`Document Id`}
							</Typography>
							<Typography sx={{ fontSize: "10px", fontWeight: "bold" }} gutterBottom>
								{`${transfer.transferDocumentNumber}`}
							</Typography>
						</Box>
                        <Box sx={{ textAlign: "left", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Typography sx={{ fontSize: "10px", fontWeight: "bold" }} gutterBottom>
								{`To`}
							</Typography>
							<Typography sx={{ fontSize: "10px", fontWeight: "bold" }} gutterBottom>
								{`${transfer.to}`}
							</Typography>
						</Box>
						<Box sx={{ textAlign: "justify", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Grid container>
								<Grid size={6}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`Crypto Amount`}
									</Typography>
								</Grid>
								<Grid size={6} sx={{ textAlign: "right" }}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`${parseFloat(transfer.cryptoAmount).toFixed(getDecimalsByCrypto(transfer.cryptoCurrency))}`}
									</Typography>
								</Grid>
							</Grid>
						</Box>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
}

export default TransferResume